import { Component, Input, ViewChild, computed, effect, inject, signal } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { concat, filter, map } from 'rxjs';
import { DxDataGridComponent, DxDropDownBoxComponent, DxFileUploaderComponent } from 'devextreme-angular';
import { DxDataGridTypes } from "devextreme-angular/ui/data-grid"
import { DataChange } from 'devextreme-angular/common/grids';
import { DialogService } from 'src/app/services/dialog.service';
import { DataService } from 'src/app/services/data.service';
import { AppstateService } from 'src/app/services/appstate.service';
import { BudgetBaunebenkostenComponent } from '../budget-baunebenkosten/budget-baunebenkosten.component';
import { IBudgetantragKostenherleitung } from 'src/app/types/IBudgetantragKostenherleitung';
import { BudgetantragKostenherleitung } from 'src/app/types/budgetantragKostenherleitung';
import { ITabData } from 'src/app/types/infrastructure/interfaces/ITabData';
import { IKostengruppe } from 'src/app/types/IKostengruppe';
import { ITeilleistung } from 'src/app/types/ITeilleistung';
import { IHuAuBau } from 'src/app/types/IHuAuBau';
import { IKostenermittlungsart } from 'src/app/types/IKostenermittlungsart';
import { IBudgetantrag } from 'src/app/types/IBudgetantrag';
import { GridService } from 'src/app/services/controls/grid.service';
import { GridSummary } from 'src/app/types/infrastructure/GridSummary';
import { ValueChangedEvent } from 'devextreme/ui/file_uploader';
import { dxDataGridColumn, EditingStartEvent, RowValidatingEvent } from 'devextreme/ui/data_grid';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import Link from "devextreme/ui/button";
import { UserService } from 'src/app/services/user.service';
import { CustomMenuItem } from 'src/app/types/infrastructure/CustomMenuItem';
import { BudgetTeilleistungenComponent } from '../budget-teilleistungen/budget-teilleistungen.component';
import { NavigationService } from 'src/app/services/navigation.service';
import { AuthService } from 'src/app/services/auth.service';
import { IFirma } from 'src/app/types/IFirma';


@UntilDestroy()
@Component({
	selector: 'app-budget-kostenherleitung',
	// standalone: true,
	// imports: [],
	templateUrl: './budget-kostenherleitung.component.html',
	styleUrl: './budget-kostenherleitung.component.scss',
	providers: [GridService]
})
export class BudgetKostenherleitungComponent {


	static instance: BudgetKostenherleitungComponent;

	@Input()
	set projektid(id: number) {
		if (id) {
			this.appStateService.projektId.set(id);
			this.appStateService.projektInfoId.set(id);
		}
	}
	@Input()
	set baid(id: number) {
		this.appStateService.budgetantragId.set(id);
	}
	@Input()
	set pageid(id: string) {
		let tab = this.tabs.find(t => t.route === id);
		this.tabIndex.set(tab ? tab.key : 0);
		this.pageId = id;

	}

	@Input()
	set modus(id: string) {
		if (id === 'Inkonsistent') {
			this.showInkonsistenteZeilen.set(true);
			this.customMenuItems()[11].selected = true;
			this.modusShow = id;
		} else if (id && !isNaN(Number(id))) {
			this.auftragID.set(parseInt(id, 10));
		}
	}




	public auftragID = signal<number | null>(null);
	public pageId?: string;
	public modusShow?: string = '';
	public tabs: ITabData[] = [];
	public tabIndex = signal<number>(0);
	public maxTextLength = 255;

	public allowEditKostenvarianz = signal(true);

	public dataBudgetantrag = computed<IBudgetantrag | null>(() => this.dataService.budgetantragDetails());
	public allowBestaetigung = computed(() => !this.dataBudgetantrag()!.freigabeFinal && this.userService.AllowBestaetigung(this.dataBudgetantrag()!.aktuelleBearbeitung));
	public allowEdit = computed(() => !this.dataBudgetantrag()!.freigabeFinal && this.userService.AllowEdit(this.dataBudgetantrag()!.aktuelleBearbeitung, this.dataBudgetantrag()!.antragstellerID, this.dataBudgetantrag()!.pstID, this.dataBudgetantrag()!.pmID));
	public isFinalized = computed(() => this.dataBudgetantrag()?.freigabeFinal);
	public isBauControlling = computed<boolean>(() => this.dataBudgetantrag()?.verwaltungsbereichID == 1);
	public isProjektNeu = computed<boolean>(() => this.dataBudgetantrag()?.budgetplanReferenz == null);
	public customMenuItems = computed<CustomMenuItem[]>(() => this.isBauControlling() ?
		[new CustomMenuItem(0, false, 'Filterung', '', true),
		new CustomMenuItem(1, true, 'Baukosten anzeigen', '', false),
		new CustomMenuItem(2, true, 'BNK 1-4 anzeigen', ''),
		new CustomMenuItem(3, true, 'BNK 5-9 anzeigen', ''),
		new CustomMenuItem(4, false, 'Filter-Zeile anzeigen', ''),
		new CustomMenuItem(5, false, 'Gruppierung', '', true, true),
		new CustomMenuItem(6, false, 'Gruppierung ausblenden', '', false),
		new CustomMenuItem(7, false, 'Kostenart gruppieren', '', false),
		new CustomMenuItem(8, true, 'Kostengruppe gruppieren', ''),
		new CustomMenuItem(9, false, 'Teilleistung gruppieren', ''),
		new CustomMenuItem(10, false, 'Ansicht', '', true, true),
		new CustomMenuItem(11, false, 'Inkonsistente Zeilen markieren', '', false),
		new CustomMenuItem(12, false, 'Toolbar / Suche  ', '', true, true),
		new CustomMenuItem(13, false, 'Toolbar / Suche / Export einblenden', '', false),
		new CustomMenuItem(14, false, 'Spalten-Suche einblenden', '', false),
		] :
		[new CustomMenuItem(0, false, 'Filterung', '', true),
		new CustomMenuItem(4, false, 'Filter-Zeile anzeigen', ''),
		new CustomMenuItem(5, false, 'Gruppierung', '', true, true),
		new CustomMenuItem(6, false, 'Gruppierung ausblenden', '', false),
		new CustomMenuItem(9, false, 'Teilleistung gruppieren', ''),
		new CustomMenuItem(10, false, 'Ansicht', '', true, true),
		new CustomMenuItem(11, false, 'Inkonsistente Zeilen markieren', '', false),
		new CustomMenuItem(12, false, 'Toolbar / Suche  ', '', true, true),
		new CustomMenuItem(13, false, 'Toolbar / Suche / Export einblenden', '', false),
		new CustomMenuItem(14, false, 'Spalten-Suche einblenden', '', false),
		]);

	@ViewChild(DxDataGridComponent, { static: false })
	public grid!: DxDataGridComponent;
	public gridInfoText = signal('');
	public gridDataCountText = signal('');
	public gridShowFilterRow = signal(false);
	public gridShowToolbar = signal(false);
	public gridShowHeaderFilter = signal(false);
	public gridWidth = computed(() => this?.appStateService?.sidenavExpanded() ? 'calc(100vw - 344px)' : 'calc(100vw - 138px)');
	public gridIsEditing = signal<boolean>(false);
	public gridIsKalkulationModified = signal<boolean>(false);
	public gridIsRowDataModified = signal<boolean>(false);

	public plangebiet = computed<number>(() => this.dataBudgetantrag()!.plangebietID);
	public dataKostengruppen = computed<IKostengruppe[] | null>(() => this.dataService.budgetantragKostenherleitung().kostengruppen);
	public dataTeilleistungen = computed<ITeilleistung[] | null>(() => this.dataService.budgetantragKostenherleitung().teilleistungen);
	//&& a.grouping01 != a.nummer.toString() && a.grouping02 != a.nummer.toString()
	public dataTeilleistungenBK = computed<ITeilleistung[] | null>(() => this.dataTeilleistungen()?.filter((a: ITeilleistung) => a.kostengruppeID === 1 ) ?? null);
	public dataTeilleistungenBNK14 = computed<ITeilleistung[] | null>(() => this.dataTeilleistungen()?.filter((a: ITeilleistung) => a.kostengruppeID === 2) ?? null);
	public dataTeilleistungenBNK59 = computed<ITeilleistung[] | null>(() => this.dataTeilleistungen()?.filter((a: ITeilleistung) => a.kostengruppeID === 4) ?? null);
	// Alles außer Kostengruppe 4 (BNK5-9) , da Nummern doppelt vorkommen in den BNK's
	public dataTeilleistungenAll = computed<ITeilleistung[] | null>(() => this.dataTeilleistungen()?.filter((a: ITeilleistung) => a.kostengruppeID != 4) ?? null);
	public dataHuAuBau = computed<IHuAuBau[] | null>(() => this.dataService.budgetantragHuAuBa());
	public dataKostenermittlungsarten = computed<IKostenermittlungsart[] | null>(() => this.dataService.budgetantragKostenherleitung().kostenermittlungsarten);
	public dataFileKalkulation = signal<File>(new File([], ''));
	public dataFileURLKalkulation = computed(() => this.dataFileKalkulation().size ? URL.createObjectURL(this.dataFileKalkulation()!) : "blob:");
	public dataTeilleistungIdAddTemp: number | null = null;


	// Alle Firmen aus dem Plangebiet + alle noch nicht angelegten Firmen aus der Kostenherleitung
	public firmenUnsaved = signal<IFirma[]>([]);
	public firmen = computed<IFirma[] | null>(() => this.dataService.firmen().concat(this.firmenUnsaved() ?? []));
	public dataKostenherleitungen = signal<IBudgetantragKostenherleitung[] | null>([]);


	private dataSummaryBaukosten: GridSummary = new GridSummary();
	private dataSummaryBNK14: GridSummary = new GridSummary();
	private dataSummaryBNK59: GridSummary = new GridSummary();

	public showGroupingKostenart = signal<boolean>(false);
	public showGroupingKostengruppe = signal<boolean>(true);
	public showGroupingTeilleistung = signal<boolean>(false);
	public showInkonsistenteZeilen = signal<boolean>(false);

	@ViewChild("dropDownBoxFileUpload", { static: false })
	dropDownBoxFileUpload!: DxDropDownBoxComponent;
	@ViewChild('fileUploader')
	fileUploader!: DxFileUploaderComponent;

	readonly dialog = inject(MatDialog);
	readonly dialogService = inject(DialogService);
	public authService: AuthService = inject(AuthService);


	constructor(public appStateService: AppstateService,
		public gridService: GridService,
		private router: Router,
		private activeRoute: ActivatedRoute,
		public dataService: DataService,
		private userService: UserService,
		public navigationService: NavigationService) {

		BudgetKostenherleitungComponent.instance = this;

		this.tabs.push({ key: 0, route: 'teilleistungen', name: 'Teilleistungen', icon: 'filter_none', invalid: false, tooltip: 'Basisinformationen / Teilleistungen / Budget' });
		this.tabs.push({ key: 1, route: 'jahreszuordnungprozent', name: 'Jahreszuordnung (%)', icon: 'percent', invalid: false, tooltip: 'Prozentuale Jahreszuordnung' });
		this.tabs.push({ key: 2, route: 'jahreszuordnungabsolut', name: 'Jahreszuordnung (abs.)', icon: 'tag', invalid: false, tooltip: 'Absolute Jahreszuordnung' });
		this.tabs.push({ key: 3, route: 'verlauf', name: 'Verlauf', icon: 'schedule', invalid: false, tooltip: 'Verlauf / Begründungen' });

		// bind component scope to functions
		this.onGridRowPopupButtonClick = this.onGridRowPopupButtonClick.bind(this);
		this.onGridRowEditButtonClick = this.onGridRowEditButtonClick.bind(this);
		this.isGridRowPopupButtonVisible = this.isGridRowPopupButtonVisible.bind(this);
		this.isGridRowDeleteButtonVisible = this.isGridRowDeleteButtonVisible.bind(this);
		this.isGridRowEditButtonVisible = this.isGridRowEditButtonVisible.bind(this);
		this.onGridInitNewRow = this.onGridInitNewRow.bind(this);
		this.onGridRowValidating = this.onGridRowValidating.bind(this);
		this.onGridCalculateGroupValueKostenart = this.onGridCalculateGroupValueKostenart.bind(this);
		this.onGridCalculateDisplayValueKostenart = this.onGridCalculateDisplayValueKostenart.bind(this);
		this.onGridCalculateGroupValueTeilleistung = this.onGridCalculateGroupValueTeilleistung.bind(this);
		this.onGridCalculateGroupValueKostengruppe = this.onGridCalculateGroupValueKostengruppe.bind(this);
		this.onGridCalculateDisplayValueKostengruppe = this.onGridCalculateDisplayValueKostengruppe.bind(this);
		this.onGridCalculateCustomSummary = this.onGridCalculateCustomSummary.bind(this);
		this.onGridCellDisplayValueBaukosten = this.onGridCellDisplayValueBaukosten.bind(this);
		this.onGridCalculateCellValueBaukosten = this.onGridCalculateCellValueBaukosten.bind(this);
		this.onGridEditorPreparing = this.onGridEditorPreparing.bind(this);
		this.onFileUploadCloseButtonClick = this.onFileUploadCloseButtonClick.bind(this);


		effect(() => {
			this.dataKostenherleitungen.set(this.dataService.budgetantragKostenherleitung().kostenherleitungen);
			this.RefreshFirmen();
		}, { allowSignalWrites: true })

		effect(() => {
			const bezugsJahr = this.dataBudgetantrag()?.bezugsJahr ?? 0;
			if (bezugsJahr !== 0 && !isNaN(bezugsJahr))
				this.gridService.Bezugsjahr.set(bezugsJahr);
		}, { allowSignalWrites: true });


		effect(() => {
			if (this.isBauControlling() || !this.isBauControlling())
				this.gridColumnVisibilities(this.tabIndex());
		})


		effect(() => {
			if (this.dataKostenherleitungen == null) {
				this.grid.instance.beginCustomLoading("Kostenherleitungen werden geladen...");
			} else {
				this.grid.instance.endCustomLoading();
			}
		});

		effect(() => {
			if (!this.gridIsEditing()) {
				this.gridIsKalkulationModified.set(false);
				this.dataFileKalkulation.set(new File([], ''));
			}
		}, { allowSignalWrites: true });

		effect(() => {
			this.dataTeilleistungen()!.forEach((teilleistung: ITeilleistung) => {
				teilleistung.bezeichnungGrouping01 = teilleistung.grouping01 + " " + this.dataTeilleistungen()!.filter((x) => x.nummer.toString() === teilleistung.grouping01)[0]?.bezeichnung;
				teilleistung.bezeichnungGrouping02 = teilleistung.grouping02 + " " + this.dataTeilleistungen()!.filter((x) => x.nummer.toString() === teilleistung.grouping02)[0]?.bezeichnung;
			});
		}, { allowSignalWrites: true });
	}

	ngOnInit() {

		this.setMenuIcons();
		// Teilleistung Gruppierung ergänzen um die Gruppierungsbezeichnungen
		// this.dataTeilleistungen()!.forEach((teilleistung: ITeilleistung) => {
		// 	teilleistung.bezeichnungGrouping01 = teilleistung.grouping01 + " " + this.dataTeilleistungen()!.filter((x) => x.nummer.toString() === teilleistung.grouping01)[0]?.bezeichnung;
		// 	teilleistung.bezeichnungGrouping02 = teilleistung.grouping02 + " " + this.dataTeilleistungen()!.filter((x) => x.nummer.toString() === teilleistung.grouping02)[0]?.bezeichnung;
		// });
	}



	RefreshFirmen() {
		// Die noch nicht angelegten Firmen werden erst mit der Freigabe angelegt
		// filter((v,i,a) => a.indexOf(v) === i) ist ein Distinct-Filter

		// die noch nicht angelegten Firmen aus den Firmennamen der Kostenherleitungen ermitteln
		var unsaved = this.dataKostenherleitungen()!.filter(k => k.firma != null && k.firma !== '' && (k.firmaId == null || k.firmaId < 0))
			.map<string>((k) => (k.firma!)).filter((v, i, a) => a.indexOf(v) === i).map<IFirma>((k, index) => ({ firmaID: -(index + 1), firmenname: k, plangebiete: [this.plangebiet()] })) ?? [];
		//console.log('Unsaved Firmen:', unsaved);
		this.firmenUnsaved.set(unsaved);

		// die temporären ID'S in den Kostenherleitungen abgleichen
		this.dataKostenherleitungen()?.filter((item) => this.firmen()?.some((firma) => firma.firmenname === item.firma) && (item.firmaId == null || item.firmaId < 0)).forEach((item) => {
			var firma = this.firmen()?.find((firma) => firma.firmenname === item.firma);
			if (firma)
				item.firmaId = firma.firmaID;
		});

	};


	// #region Panel

	BackButtonClicked() {
		if (this.grid.instance.hasEditData())
			this.grid.instance.saveEditData();
		if (this.modusShow === 'Inkonsistent')
			this.navigationService.navigateToFreigabeFromKostenherleitung(this.activeRoute);
		else
			this.router.navigate(['../../'], { relativeTo: this.activeRoute });
	}

	onTeilleistungenClick() {
		var ids = this.dataKostenherleitungen()!.map((item: any) => item.teilleistungId);
		// distinct array
		ids = [...new Set(ids)];

		const dialogRef = this.dialog.open(BudgetTeilleistungenComponent, {
			height: '762px',
			width: '750px',
			disableClose: true,
			data: {
				title: 'Teilleistungen hinzufügen',
				message: 'Bitte wählen Sie die noch nicht vorhandenen Teilleistungen aus, für die Kostenherleitungen erstellt werden sollen.',
				idsExisting: ids,
				allowEdit: this.allowEdit(),
				isBauControlling: this.isBauControlling()
			},
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result?.idsSelected?.length >= 1) {

				var kostenherleitungen: BudgetantragKostenherleitung[] = [];
				result.idsSelected.forEach((id: number) => {
					// save new Kostenherleitung
					var kostenherleitung = new BudgetantragKostenherleitung();
					kostenherleitung.teilleistungId = id;
					kostenherleitung.kostengruppeId = result.kostengruppenId;
					kostenherleitung.budgetantragId = this.appStateService.budgetantragId()!;
					kostenherleitung.stand = new Date();
					kostenherleitungen.push(kostenherleitung);
				});

				// neues Token holen, falls das alte abgelaufen ist
				this.authService.setAuthInfo().then(() => {
					this.dataService.createBudgetantragKostenherleitungen(this.appStateService.budgetantragId(), kostenherleitungen).subscribe({
						next: (data) => {

							// data.forEach((result: BudgetantragKostenherleitung) => {
							//   result.isInitialized = true;
							//   this.dataKostenherleitungen()?.push(result);
							// });

							this.dataService.refreshBudgetantragKostenherleitung();
							var message = result.idsSelected.length == 1 ?
								'Es wurde eine Kostenherleitungen gespeichert' :
								`Es wurden ${data.length} Kostenherleitungen gespeichert`
							this.dialogService.showMessageSheet(message);
						},
						error: (err: HttpErrorResponse) => {
							this.dialogService.showMessageSheet('Fehler beim Speichern der Kostenherleitungen');
						}
					});
				});
			}
		});
	}

	BaunebenkostenClicked() {
		const dialogRef = this.dialog.open(BudgetBaunebenkostenComponent, {
			height: '494px',
			width: '50vw',
			disableClose: true,
			data: { name: 'Name', title: 'Titel' },
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result == true) {
				this.grid.instance.refresh();
				this.dialogService.showMessageSheet('Die Baunebenkosten wurden gespeichert');
			}
		});
	}

	onPreissteigerungClick() {
		this.tabIndex.set(1);
		var scroll = this.grid.instance.getScrollable();
		var offset = scroll.scrollHeight() > scroll.clientHeight();
		this.appStateService.budgetantragPreissteigerungId.set(null);
		this.appStateService.budgetantragPreissteigerungId.set(this.appStateService.budgetantragId());
		this.dialogService.showPreissteigerungSheet(offset, this.gridService.Bezugsjahr());
	}


	onUpdateAuftragswerteClick() {
		this.dialogService.showDialog("Sollen die Kostenherleitungen jetzt mit den aktuellen Auftragswerten aktualisiert werden?", "Aktualisieren").subscribe(result => {
			if (result == true) {
				this.dialogService.showMessageSheet('Bitte warten - die Auftragswerte werden aktualisiert!', 0, true, undefined, 4000);
				this.dataService.updateBudgetantragKostenherleitungenAuftragswerte(this.appStateService.budgetantragId()).subscribe({
					next: (data) => {
						this.grid.instance.refresh();
						this.dialogService.showMessageSheet('Die Auftragswerte wurden erfolgreich aktualisiert');
					}
				});
			}
		});
	}

	onCustomMenuButton1ItemClick(e: CustomMenuItem) {
		var filterValue: (string | (string | number)[][])[] = [];
		this.grid.instance.clearFilter();

		// toggle selection
		e.selected = !e.selected;

		// rebuild filter value based on selected items
		this.customMenuItems().forEach(item => {
			if (!item.selected && item.id >= 1 && item.id <= 3) {
				if (filterValue.length > 0) filterValue.push('and');

				if (item.id == 1) {
					// Baukosten
					filterValue.push([['kostengruppeId', '<>', 1]]);
				} else if (item.id == 2) {
					// BNK1-4
					filterValue.push([['kostengruppeId', '<>', 2]]);
				} else if (item.id == 3) {
					// BNK5-9
					filterValue.push([['kostengruppeId', '<>', 4]]);
				}
			}
		});

		if (e.id == 4) {
			this.gridShowFilterRow.set(!this.gridShowFilterRow());
			this.customMenuItems()[4].selected = this.gridShowFilterRow();
		}
		else if (e.id == 6) {
			// Grouping
			if (e.selected) {
				this.showGroupingKostenart.set(false);
				this.showGroupingKostengruppe.set(false);
				this.showGroupingTeilleistung.set(false);
			} else {
				this.showGroupingKostenart.set(true);
				this.showGroupingKostengruppe.set(true);
				this.showGroupingTeilleistung.set(true);
			}
			this.customMenuItems().forEach(item => {
				if (item.id >= 7 && item.id <= 9) {
					item.selected = !e.selected;
				}
			});
		} else if (e.id == 7) {
			this.showGroupingKostenart.set(e.selected);
			this.customMenuItems().find(item => item.id === 6)!.selected = false;
			if (!this.customMenuItems().find(item => item.id === 7)?.selected && !this.customMenuItems().find(item => item.id === 8)?.selected && !this.customMenuItems().find(item => item.id === 9)?.selected) {
				this.customMenuItems().find(item => item.id === 6)!.selected = true;
			}
		} else if (e.id == 8) {
			this.showGroupingKostengruppe.set(!this.showGroupingKostengruppe());
			this.customMenuItems().find(item => item.id === 6)!.selected = false;
			if (!this.customMenuItems().find(item => item.id === 7)?.selected && !this.customMenuItems().find(item => item.id === 8)?.selected && !this.customMenuItems().find(item => item.id === 9)?.selected) {
				this.customMenuItems().find(item => item.id === 6)!.selected = true;
			}
		} else if (e.id == 9) {
			this.showGroupingTeilleistung.set(!this.showGroupingTeilleistung());
			this.customMenuItems().find(item => item.id === 6)!.selected = false;
			if (!this.customMenuItems().find(item => item.id === 7)?.selected && !this.customMenuItems().find(item => item.id === 8)?.selected && !this.customMenuItems().find(item => item.id === 9)?.selected) {
				this.customMenuItems().find(item => item.id === 6)!.selected = true;
			}
		} else if (e.id == 11) {
			this.showInkonsistenteZeilen.set(!this.showInkonsistenteZeilen());
			this.grid.instance.refresh();
		} else if (e.id == 13) {
			this.gridShowToolbar.set(!this.gridShowToolbar());
			this.grid.instance.option('selection.mode', this.gridShowToolbar() ? 'multiple' : 'single');
			this.customMenuItems().find(item => item.id === 13)!.selected = this.gridShowToolbar();
		} else if (e.id == 14) {
			this.gridShowHeaderFilter.set(!this.gridShowHeaderFilter());
			this.customMenuItems().find(item => item.id === 14)!.selected = this.gridShowHeaderFilter();
		}
		if (filterValue.length > 0) {
			this.grid.instance.filter(filterValue);
		}
		this.setMenuIcons();
	}

	setMenuIcons() {
		this.customMenuItems().filter(x => !x.disabled).forEach(item => {
			item.icon = item.selected ? 'check_box' : 'check_box_outline_blank';
		});
	};

	GetSeitenStatus(index: number): boolean {
		if (index == 0) return this.dataBudgetantrag()!.ysnSeite1;
		if (index == 1) return this.dataBudgetantrag()!.ysnSeite2;
		if (index == 2) return this.dataBudgetantrag()!.ysnSeite3;
		if (index == 3) return this.dataBudgetantrag()!.ysnSeite4;
		return false;
	}

	// #endregion

	// #region Tabs

	onTabIndexChange(index: any) {
		let selectedTab = this.tabs.find(t => t.key === index);
		this.router.navigate(['../', selectedTab?.route], { relativeTo: this.activeRoute });
		this.tabIndex.set(index);
		this.gridColumnVisibilities(index);
	}

	private gridColumnVisibilities(index: any) {
		if (this.grid == null) return;

		this.grid.instance.beginUpdate();

		// group columns only visible for baucontrolling
		this.grid.instance.columnOption("kostengruppeArt", "visible", this.isBauControlling());
		this.grid.instance.columnOption("kostengruppeId", "visible", this.isBauControlling());
		//this.grid.instance.columnOption("teilleistungId", "visible", this.isBauControlling());
		//this.grid.instance.columnOption("teilleistungId", "showWhenGrouped", this.isBauControlling() && index == 0 && this.gridIsEditing());
		this.grid.instance.columnOption("bandHuAuBau", "visible", this.isBauControlling() && index == 0);

		this.grid.instance.columnOption("bandAuftragswert", "visible", index == 0);
		this.grid.instance.columnOption("bandBasiskosten", "visible", index == 0);
		this.grid.instance.columnOption("bandKostenVarianz", "visible", this.isBauControlling() && index == 0);
		this.grid.instance.columnOption("bandKalkulation", "visible", index == 0);

		this.grid.instance.columnOption("bandIstKostenProzent", "visible", index == 1);
		this.grid.instance.columnOption("bandLeistungsabflussProzent", "visible", index == 1);
		this.grid.instance.columnOption("bandSummeProzent", "visible", index == 1);

		this.grid.instance.columnOption("bandIstKosten", "visible", index == 2);
		this.grid.instance.columnOption("bandLeistungsabfluss", "visible", index == 2);
		this.grid.instance.columnOption("bandSumme", "visible", index == 2);

		this.grid.instance.columnOption("baukostenLetztgueltig", "visible", index == 3);
		this.grid.instance.columnOption("differenzLetztgueltig", "visible", index == 3);
		this.grid.instance.columnOption("differenzLetztgueltigProzent", "visible", index == 3);
		this.grid.instance.columnOption("bandBegruendungen", "visible", index == 3);
		this.grid.instance.columnOption("kostenvarianzBegruendung2", "visible", this.isBauControlling());
		this.grid.instance.columnOption("huAuBauBegruendung", "visible", this.isBauControlling());

		this.grid.instance.columnOption("bandkontrolle", "visible", index == 1 || index == 2);

		this.grid.instance.endUpdate();
	}

	// #endregion

	// #region Grid CRUD

	onGridRowSaving(e: any) {
		if (e.changes.length == 0) {
			e.cancel = true;
		}
	}

	onGridRowSaved(e: any) {
		if (e.changes.length == 0) {
			this.gridIsEditing.set(false);
			this.tabs.forEach(tab => tab.invalid = false);
			return;
		}

		// Eventuell ein neues Token holen, sonst kann nichts gespeichert werden, wenn das Token abgelaufen ist
		this.authService.setAuthInfo().then(() => {
			e.changes.forEach((row: DataChange) => {
				if (row.data.kontrolle == true && this.dataBudgetantrag()!.ysnSeite3 == true) {
					this.dataBudgetantrag()!.ysnSeite3 = false;
					this.saveBudgetantrag();
				}
				// ToDo: huAuBauId is not nullable, so technical value is stored
				// if (row.data.huAuBauId == 99 || row.data.huAuBauId == 98) row.data.huAuBauId = null;
				if (row.data.huAuBauBegruendung2 == 99 || row.data.huAuBauBegruendung2 == 98) row.data.huAuBauBegruendung2 = null;
				if (row.data.kostenermittlungsart == 99 || row.data.kostenermittlungsart == 98) row.data.kostenermittlungsart = null;
				if (row.data.kostenvarianz == 99 || row.data.kostenvarianz == 98) row.data.kostenvarianz = null;
				if (row.data.kostenvarianzBegruendung3 == 99 || row.data.kostenvarianzBegruendung3 == 98) row.data.kostenvarianzBegruendung3 = null;

				if (row.type === "insert") {
					this.dataService.createBudgetantragKostenherleitung(this.appStateService.budgetantragId(), row.data).subscribe({
						next: (data) => {
							// Zurückgliefertes Objekt in die Liste einfügen
							this.dataKostenherleitungen()![this.dataKostenherleitungen()!.length - 1] = data;
							this.RefreshFirmen();


							if (this.dataFileKalkulation().size) {
								// save pdf file kalkulation
								const formData = new FormData();
								formData.append("file", this.dataFileKalkulation()!, row.data.dateipfadPDFKalkulation);
								this.dataService.updateBudgetantragKostenherleitungKalkulation(this.appStateService.budgetantragId()!, data.kostenHerleitungId!, formData).subscribe({
									next: (data: any) => {
										this.gridIsEditing.set(false);
										this.dialogService.showMessageSheet('Die Kostenherleitung wurde erfolgreich aktualisiert.');
									},
									error: (err: HttpErrorResponse) => {
										this.gridIsEditing.set(false);
									}
								});
							} else {
								// no file to save
								this.gridIsEditing.set(false);
								this.dialogService.showMessageSheet('Die Kostenherleitung wurde erfolgreich erstellt.');
								this.grid.instance.refresh();
							}
						},
						error: (err: HttpErrorResponse) => {
							this.dataKostenherleitungen()?.pop()
							this.gridIsEditing.set(false);
						}
					});
				} else if (row.type === "update") {
					this.dataService.updateBudgetantragKostenherleitung(this.appStateService.budgetantragId(), row.key, row.data).subscribe({
						next: (data) => {
							// is kalkulation file modified and not deleted
							this.RefreshFirmen();

							if (this.gridIsKalkulationModified() && this.dataFileKalkulation().size) {
								// save kalkulation file
								const formData = new FormData();
								formData.append("file", this.dataFileKalkulation()!, row.data.dateipfadPDFKalkulation);
								this.dataService.updateBudgetantragKostenherleitungKalkulation(this.appStateService.budgetantragId()!, row.key, formData).subscribe({
									next: (data: any) => {
										this.gridIsEditing.set(false);
										this.dialogService.showMessageSheet('Die Kostenherleitung wurde erfolgreich aktualisiert.');
										this.grid.instance.refresh();
									},
									error: (err: HttpErrorResponse) => {
										this.gridIsEditing.set(false);
									}
								});
							} else {
								this.gridIsEditing.set(false);
								this.dialogService.showMessageSheet('Die Kostenherleitung wurde erfolgreich aktualisiert.');
							}
						},
						error: (err: HttpErrorResponse) => {
							this.gridIsEditing.set(false);
							this.dialogService.showMessageSheet('Die Kostenherleitung konnte nicht gespeichert werden. Bitte überprüfen Sie die Eingaben.');
						}
					});
				}
			});
		});
	}

	onGridRowCanceled(e: any) {
		this.tabs.forEach(tab => tab.invalid = false);
		this.gridIsEditing.set(false);
	}

	onGridRowRemoved(e: any) {
		this.gridIsEditing.set(false);
		if (!e.key) return;

		// refresh needed to calculate values of teilleistung "Sontiges" and recalculate summaries
		// e.component.refresh();

		this.dataService.deleteBudgetantragKostenherleitung(this.appStateService.budgetantragId(), e.key).subscribe({
			next: (data) => {
				this.dialogService.showMessageSheet('Die Kostenherleitung wurde gelöscht.');
			},
			error: (err: HttpErrorResponse) => {
			}
		});
	}

	onGridCheckButtonClick(index: number | undefined, e: any) {

		var tabDetails = '';
		var tabValue = false;
		var dialogMessage = '';
		var dialogTitle = '';
		var ctrlKeyPressed = e && e.ctrlKey;

		if (index != undefined)
			this.tabIndex.set(index);

		if (this.tabIndex() == 0) {
			tabValue = this.dataBudgetantrag()!.ysnSeite1;
			tabDetails = 'der Teilleistungen (Seite 1)';
		} else if (this.tabIndex() == 1) {
			tabValue = this.dataBudgetantrag()!.ysnSeite2;
			tabDetails = 'der prozentualen Jahreszuordnungen (Seite 2)';
		} else if (this.tabIndex() == 2) {
			if (this.dataBudgetantrag()!.ysnSeite3 == false && this.checkKostenherleitungInkonsistent(0)) {
				return;
			}
			tabValue = this.dataBudgetantrag()!.ysnSeite3;
			tabDetails = 'der absoluten Jahreszuordnungen (Seite 3)';
		} else if (this.tabIndex() == 3) {
			tabValue = this.dataBudgetantrag()!.ysnSeite4;
			tabDetails = 'der Verläufe (Seite 4)';
		}

		if (tabValue == false) {
			dialogMessage = `Die Konsistenz ${tabDetails} wird bestätigt!`;
			dialogTitle = 'Bestätigung der Konsistenz';
		} else {
			dialogMessage = `Die Konsistenz ${tabDetails} wird nicht bestätigt!`;
			dialogTitle = 'Rücknahme der Bestätigung';
		}

		this.dialogService.showDialog(dialogMessage, dialogTitle, 'Möchten Sie fortfahren?', 260, 560).subscribe(result => {
			if (result == true) {
				if (ctrlKeyPressed) {
					// CTRL key pressed -> toggle all tabs
					var newValue = !tabValue;
					this.dataBudgetantrag()!.ysnSeite1 = newValue;
					this.dataBudgetantrag()!.ysnSeite2 = newValue;
					if (!this.checkKostenherleitungInkonsistent(1500))
						this.dataBudgetantrag()!.ysnSeite3 = newValue;
					this.dataBudgetantrag()!.ysnSeite4 = newValue;
				} else {
					if (this.tabIndex() == 0) {
						this.dataBudgetantrag()!.ysnSeite1 = !tabValue;
					} else if (this.tabIndex() == 1) {
						this.dataBudgetantrag()!.ysnSeite2 = !tabValue;
					} else if (this.tabIndex() == 2) {
						this.dataBudgetantrag()!.ysnSeite3 = !tabValue;
					} else if (this.tabIndex() == 3) {
						this.dataBudgetantrag()!.ysnSeite4 = !tabValue;
					}
				}
				this.saveBudgetantrag();
			}
		});
	}


	saveBudgetantrag() {
		// POST
		this.dataService.updateBudgetantrag(this.appStateService.budgetantragId()!, this.dataBudgetantrag()!).subscribe({
			next: (data) => {
				this.dataService.budgetantragDetails.set(data.body!);
				this.dataService.refreshBudgetantragKostenUndFreigabe();
				this.dialogService.showMessageSheet('Der Budgetantrag wurde erfolgreich aktualisiert.');
			},
			error: (err: HttpErrorResponse) => {
			}
		});
	}

	checkKostenherleitungInkonsistent(wait: number): boolean {
		var value = this.dataKostenherleitungen()!.some(kh => kh.kontrolle)
		if (value) {
			this.dialogService.showMessageSheet('Es sind inkonsistente Kostenherleitungen vorhanden. Bitte beheben Sie diese, bevor Sie die Konsistenz für die Jahreszuordnung (abs.) bestätigen können.', wait, true, "bottom");
			this.showInkonsistenteZeilen.set(true);
			this.grid.instance.refresh();
		}
		return value;
	}


	onGridRowValidating(e: any) {
		// no visual feedback in dialog
		if (this.isGridEditModePopup()) return;

		this.tabs.forEach(tab => tab.invalid = false);
		var message: string[] = [];
		e.brokenRules.forEach((rule: any) => {
			if (rule.column.dataField === "kostengruppeId") {
				if (rule.isValid == false) {
					this.tabs[0].invalid = true;
					message[rule.columnIndex] = rule.message;
				}
			}
			if (rule.column.dataField === "teilleistungId") {
				if (rule.isValid == false) {
					this.tabs[0].invalid = true;
					message[rule.columnIndex] = rule.message;
				}
			}
			if (rule.column.dataField === "vertragsgegenstand") {
				if (rule.isValid == false) {
					this.tabs[0].invalid = true;
					message[rule.columnIndex] = rule.message;
				}
			}
			if (rule.column.dataField === "firmaId") {
				if (rule.isValid == false) {
					this.tabs[0].invalid = true;
					message[rule.columnIndex] = rule.message;
				}
			}
			if (rule.column.dataField === "stand") {
				if (rule.isValid == false) {
					this.tabs[0].invalid = true;
					message[rule.columnIndex] = rule.message;
				}
			}
			if (rule.column.dataField === "huAuBauId") {
				if (rule.isValid == false) {
					this.tabs[0].invalid = true;
					message[rule.columnIndex] = rule.message;
				}
			}
			if (rule.column.dataField === "quelle") {
				if (rule.isValid == false) {
					this.tabs[0].invalid = true;
					message[rule.columnIndex] = rule.message;
				}
			}
			if (rule.column.dataField === "basiskostenBudget") {
				if (rule.isValid == false) {
					this.tabs[0].invalid = true;
					message[rule.columnIndex] = rule.message;
				}
			}
			if (rule.column.dataField === "kostenermittlungsart") {
				if (rule.isValid == false) {
					this.tabs[0].invalid = true;
					message[rule.columnIndex] = rule.message;
				}
			}
			if (rule.column.dataField === "kostenvarianzBegruendung") {
				if (rule.isValid == false) {
					this.tabs[0].invalid = true;
					message[rule.columnIndex] = rule.message;
				}
			}
			if (rule.column.dataField === "huAuBauBegruendung") {
				if (rule.isValid == false) {
					this.tabs[3].invalid = true;
					message[rule.columnIndex] = rule.message;
				}
			}
			if (rule.column.dataField === "veraenderungBegruendung") {
				if (rule.isValid == false) {
					this.tabs[3].invalid = true;
					message[rule.columnIndex] = rule.message;
				}
			}
		});
		e.errorText = '';
		message.forEach((element: string) => e.errorText += element + '  |  ');
		var lastIndex = e.errorText.lastIndexOf('  |  ');
		e.errorText = e.errorText.substring(0, lastIndex);
	}

	// #endregion

	// #region Grid Editing

	onGridRowDblClick(e: any) {
		if (!this.allowEdit()) return;
		//aktuelle Zeile wird schon editiert
		if (!e.isEditing) {
			if (this.grid.instance.hasEditData())
				this.grid.instance.saveEditData().then(() => {
					// Hier nocheinmal prüfen, ob Plausibilitätsprüfung gescheitert ist, dann nicht die Zeile wechseln
					if (!this.grid.instance.hasEditData())
						this.ExecuteRowDblClick(e);
				})
			else
				this.ExecuteRowDblClick(e);
		}
	}

	ExecuteRowDblClick(e: any) {
		if (e.rowType === "data") {
			// if (this.isTeileistungSonstiges(e.data?.teilleistungId)) return;

			this.gridIsEditing.set(true);
			this.gridColumnVisibilities(this.tabIndex());

			this.grid.instance.option('editing.mode', 'row');
			this.grid.instance.editRow(e.rowIndex);
		}
	}

	onGridEditingStart(e: any) {
		this.gridIsEditing.set(true);

		if (e.data.kostengruppeId && e.data.kostengruppeId !== 1) {
			this.allowEditKostenvarianz.set(false);
		} else {
			this.allowEditKostenvarianz.set(true);
		}

		if (e.data.dateipfadPDFKalkulation && this.dataFileKalkulation().size == 0) {
			if (e.data.kostenHerleitungId) {
				// load file 
				this.dataService.readBudgetantragKostenherleitungKalkulation(this.appStateService.budgetantragId(), e.data.kostenHerleitungId!).subscribe({
					next: (data: any) => {
						this.dataFileKalkulation.set(data);
					}
				});
			}
		}

		// force initial validation 
		setTimeout(() => {
			let instance = this.grid.instance as any;
			let rowIndex = instance.getRowIndexByKey(e.key);
			// fake changes to be applied
			let value = instance.cellValue(rowIndex, "stand");
			instance.cellValue(rowIndex, "stand", value);
			// validate row
			let val = instance.getController("validating");
			val.validate(true)
			// discard faked changes
			this.grid.instance.resetOption("editing.changes");
		}, 300);

	}

	onGridEditorPreparing(e: any) {
		if (e.parentType !== "dataRow") return;

		if (e.row.isNewRow) {
			// new row
			if (e.dataField === "auftragsnummer") e.editorOptions.readOnly = false;
			if (e.dataField === "vertragsgegenstand") e.editorOptions.readOnly = false;
			if (e.dataField === "firmaId") e.editorOptions.readOnly = false;
			if (e.dataField === "schlussgerechnet") e.editorOptions.readOnly = true;
		} else {
			// row edit
			var existingAuftrag = (e.row.data && (e.row.data.auftrag != undefined || e.row.data.disabled));
			if (e.dataField === "kostengruppeId") e.editorOptions.readOnly = existingAuftrag;
			if (e.dataField === "auftragsnummer") e.editorOptions.readOnly = existingAuftrag;
			if (e.dataField === "vertragsgegenstand") e.editorOptions.readOnly = existingAuftrag;
			if (e.dataField === "firmaId") e.editorOptions.readOnly = existingAuftrag;
			if (e.dataField === "jahrVergangenheitProzent") e.editorOptions.readOnly = existingAuftrag;
			if (e.dataField === "jahrVergangenheit") e.editorOptions.readOnly = existingAuftrag;
			if (e.dataField === "schlussgerechnet") e.editorOptions.readOnly = !existingAuftrag;
		}

		//console.log("onGridEditorPreparing", e.dataField, e.row.isNewRow, e.row.isEditing, e.editorName, e.editorOptions);

		if (e.dataField === "huAuBauId") {
			if (e.row.data.kostengruppeId && e.row.data.kostengruppeId !== 1) {
				e.editorOptions.readOnly = true;
				e.editorOptions.labelMark = "";
				// clear value for huAuBauId
				if (e.editorOptions.value == 99) e.editorOptions.value = undefined;
			} else {
				e.editorOptions.labelMark = " *";
				// clear value for huAuBauId
				if (e.editorOptions.value == 98) e.editorOptions.value = undefined;
			}
			e.editorOptions.onOpened = function (arg: any) {
				var popupInstance = arg.component._popup;
				popupInstance.option('width', 250);
			}
		}

		if (e.dataField === "huAuBauBegruendung2") {
			if (e.row.data.kostengruppeId && e.row.data.kostengruppeId !== 1) {
				e.editorOptions.readOnly = true;
				// clear value for huAuBauBegruendung2
				if (e.editorOptions.value == 99) e.editorOptions.value = undefined;
			}
			else {
				e.editorOptions.readOnly = !(e.editorName === "dxTextBox");
				// clear value for huAuBauBegruendung2
				if (e.editorOptions.value == 98) e.editorOptions.value = undefined;
			}
		}

		if (e.dataField === "kostenermittlungsart") {
			if (e.row.data.kostengruppeId && e.row.data.kostengruppeId !== 1) {
				e.editorOptions.readOnly = true;
				e.editorOptions.labelMark = "";
				// clear value for huAuBauId
				if (e.editorOptions.value == 99) e.editorOptions.value = undefined;
			} else {
				e.editorOptions.labelMark = " *";
				// clear value for huAuBauId
				if (e.editorOptions.value == 98) e.editorOptions.value = undefined;
			}

			e.editorOptions.onOpened = function (arg: any) {
				var popupInstance = arg.component._popup;
				popupInstance.option('width', 250);
			}
		}

		if (e.dataField === "kostenvarianz") {
			if (e.row.data.kostengruppeId && e.row.data.kostengruppeId !== 1) {
				e.editorOptions.readOnly = true;
				e.editorOptions.labelMark = "";
				// clear value for huAuBauId
				if (e.editorOptions.value == 99) e.editorOptions.value = undefined;
			} else {
				// clear value for huAuBauId
				if (e.editorOptions.value == 98) e.editorOptions.value = undefined;
			}
		}

		if (e.dataField === "kostenvarianzBegruendung") {
			if (e.row.data.kostengruppeId && e.row.data.kostengruppeId !== 1)
				e.editorOptions.readOnly = true;
			else
				e.editorOptions.readOnly = !(e.editorName === "dxTextArea");
		}

		if (e.dataField === "kostenvarianzBegruendung3") {
			if (e.row.data.kostengruppeId && e.row.data.kostengruppeId !== 1) {
				e.editorOptions.readOnly = true;
				// clear value for kostenvarianzBegruendung3
				if (e.editorOptions.value == 99) e.editorOptions.value = undefined;
			}
			else {
				e.editorOptions.readOnly = !(e.editorName === "dxTextBox");
				// clear value for kostenvarianzBegruendung3
				if (e.editorOptions.value == 98) e.editorOptions.value = undefined;
			}
		}

		if (e.dataField === "gesamtAuftragswert") e.editorOptions.readOnly = true;
		if (e.dataField === "istStandAuftrag") e.editorOptions.readOnly = true;
		if (e.dataField === "prognose") e.editorOptions.readOnly = true;
		if (e.dataField === "kostenvarianzWert") e.editorOptions.readOnly = true;
		if (e.dataField === "baukosten") e.editorOptions.readOnly = true;
		if (e.dataField === "jahrSummeProzent") e.editorOptions.readOnly = true;
		if (e.dataField === "restProzent") e.editorOptions.readOnly = true;
		if (e.dataField === "baukostenLetztgueltig") e.editorOptions.readOnly = true;
		if (e.dataField === "differenzLetztgueltig") e.editorOptions.readOnly = true;
		if (e.dataField === "differenzLetztgueltigProzent") e.editorOptions.readOnly = true;
		if (e.dataField === "jahrSumme") e.editorOptions.readOnly = true;
		if (e.dataField === "rest") e.editorOptions.readOnly = true;
	}

	onGridRowEditButtonClick(e: any) {
		if (!this.allowEdit()) return;

		if (e.row.rowType === "data") {
			this.gridIsEditing.set(true);
			this.gridColumnVisibilities(this.tabIndex());

			this.grid.instance.option('editing.mode', 'row');
			this.grid.instance.editRow(e.row.rowIndex);
		}
	}

	onGridRowPopupButtonClick(e: any) {
		if (!this.allowEdit()) return;

		this.grid.instance.option('editing.mode', 'popup');
		if (e.row.rowType === "data") {
			this.grid.instance.editRow(e.row.rowIndex);
		}
	}

	isGridRowEditButtonVisible(e: any) {
		if (!this.allowEdit()) return false;

		if (e.row.rowType === "data") {
			if (e.row.isEditing) return false;
			//  if (this.isTeileistungSonstiges(e.row.data?.teilleistungId)) return false;
		}
		return true;
	}

	isGridRowPopupButtonVisible(e: any) {
		if (!this.allowEdit()) return false;

		if (e.row.rowType === "data") {
			if (e.row.isEditing) return false;
			if (this.grid.instance.option('editing.mode') == 'batch') return false;
			//   if (this.isTeileistungSonstiges(e.row.data?.teilleistungId)) return false;
		}
		return true;
	}

	isGridRowDeleteButtonVisible(e: any) {
		if (!this.allowEdit()) return false;

		if (e.row.rowType === "data") {
			if (e.row.isEditing) return false;
			if (e.row.data.auftrag) return false;
			if (this.isTeileistungSonstiges(e.row.data?.teilleistungId)) return false;
		}
		return true;
	}

	isGridRowSaveButtonVisible(e: any) {
		if (e.row.rowType === "data") {
			if (e.row.isEditing) return true;
		}
		return false;
	}

	isGridEditModePopup() {
		return (this.grid && this.grid.instance.option('editing.mode') == 'popup');
	}

	isGridEditModeRow() {
		return (this.grid && this.grid.instance.option('editing.mode') == 'row');
	}

	isGridCurrentEditRow(rowIndex: number | undefined) {
		if (rowIndex == null || !this.grid?.instance) return false;

		const editRowKey = this.grid.instance.option('editing.editRowKey');
		if (editRowKey == null) return false;

		return rowIndex === this.grid.instance.getRowIndexByKey(editRowKey);
	}

	// #endregion

	// #region Grid Adding

	onGridAddRowButtonClick() {
		this.grid.instance.option('editing.mode', 'popup');
		this.grid.instance.addRow();
	}

	onGridInitNewRow(e: any) {
		e.data = new BudgetantragKostenherleitung();
		e.data.budgetantragId = this.appStateService.budgetantragId;
		e.data.stand = new Date();
		if (this.dataTeilleistungIdAddTemp) {
			e.data.teilleistungId = this.dataTeilleistungIdAddTemp;
		}
		e.data.isInitialized = true;
	}

	// #endregion

	// #region Grid Events

	onGridInitialized(e: any) {
		this.gridColumnVisibilities(this.tabIndex());
	}

	onGridContentReady(e: any) {
		if (e.component.getCombinedFilter() != null) {
			this.gridInfoText.set('Tabellenfilterung aktiv');
		} else {
			this.gridInfoText.set('');
		}
		this.gridDataCountText.set(e.component.totalCount() + ' Datensätze');
		if (this.auftragID() && this.grid?.instance) {
			const dataSource = this.dataKostenherleitungen();
			const item = dataSource?.find(k => k.auftragId === this.auftragID());
			if (item) {
				//this.grid.instance.selectRows([item], false);
				this.grid.instance.option('focusedRowKey', item.kostenHerleitungId);
				this.grid.instance.navigateToRow(item.kostenHerleitungId);
			}
		}
	}


	onGridRowPrepared(e: any) {
		var ausnahmen = ["Finanzamt", "HafenCity Hamburg GmbH", "Sonstiges"];
		if (e.rowType === "data" && this.showInkonsistenteZeilen()) {
			if (!ausnahmen.includes(e.data.firmaId) && (e.data.basiskostenBudget == undefined || e.data.basiskostenBudget == 0 || e.data.rest != 0)) {
				e.rowElement.style.backgroundColor = "#ffe0e0";
			}
		}
	}

	onGridCellPrepared(e: any) {

		if (e.rowType === "group") {
			// grouping cells

			// spacer
			if (e.columnIndex === 0) {
				if (e.cellElement.classList.contains("dx-datagrid-group-space")) {
					e.cellElement.classList.add("dx-group-index-01-space")
				}
			} else if (e.columnIndex === 1) {
				if (e.cellElement.classList.contains("dx-datagrid-group-space")) {
					e.cellElement.classList.add("dx-group-index-02-space")
				}
			} else if (e.columnIndex === 2) {
				if (e.cellElement.classList.contains("dx-datagrid-group-space")) {
					e.cellElement.classList.add("dx-group-index-03-space")
				}
			}

			// grouped cells
			if (e.column.dataField === "kostengruppeArt") {
				if (e.cellElement.classList.contains("dx-datagrid-group-space")) {
					e.cellElement.classList.add("dx-group-index-01");
				}
			}
			if (e.column.dataField === "kostengruppeId") {
				if (e.cellElement.classList.contains("dx-datagrid-group-space")) {
					e.cellElement.classList.add("dx-group-index-02");
				}
			}
			if (e.column.dataField === "teilleistungId") {
				if (e.cellElement.classList.contains("dx-datagrid-group-space")) {
					e.cellElement.classList.add("dx-group-index-03");
				}
			}
		}

		if (e.rowType === "data") {
			// data rows

			e.cellElement.addEventListener('contextmenu', (event: MouseEvent) => {
				event.preventDefault();
				if (this.gridIsEditing() && !e.column.dataField.includes("Vergangenheit") && !e.column.dataField.includes("Prozent") && e.column.dataField.startsWith("jahr") && e.data) {
					//e.data[e.column.dataField]
					e.setValue(e.data["rest"] == 0 ? null : (e.data[e.column.dataField] + e.data["rest"]));
					this.grid.instance.refresh();
				}
			});
			if (e.value && (e.column.dataField === "quelle" || e.column.dataField === "veraenderungBegruendung" ||
				e.column.dataField === "huAuBauBegruendung" || e.column.dataField === "kostenvarianzBegruendung" ||
				e.column.dataField === "huAuBauBegruendung2" || e.column.dataField === "kostenvarianzBegruendung2" || e.column.dataField === "kostenvarianzBegruendung3"))
				e.cellElement.title = e.value;

			if (this.isBauControlling()) {
				// spacer
				if (e.columnIndex === 0) {
					if (e.cellElement.classList.contains("dx-datagrid-group-space")) {
						e.cellElement.classList.add("dx-group-index-01-space")
					}
				} else if (e.columnIndex === 1) {
					if (e.cellElement.classList.contains("dx-datagrid-group-space")) {
						e.cellElement.classList.add("dx-group-index-02-space")
					}
				} else if (e.columnIndex === 2) {
					if (e.cellElement.classList.contains("dx-datagrid-group-space")) {
						e.cellElement.classList.add("dx-group-index-03-space")
					}
				} else {
					if (e.column.dataField == "dateipfadPDFKalkulation") {
						e.cellElement.classList.add("dx-command-edit-with-icons")
					}
					// data cells
					e.cellElement.classList.add("dx-data-custom");
				}
			}

			if (e.row.isEditing) {
				// Validate required fields while editing row
				if (e.column.dataField === "kostengruppeId") {
					if (e.value == undefined) e.cellElement.classList.add("dx-datagrid-invalid");
				}
				if (e.column.dataField === "teilleistungId") {
					if (e.value == undefined) e.cellElement.classList.add("dx-datagrid-invalid");
				}
				if (e.column.dataField === "huAuBauId" && this.allowEditKostenvarianz()) {
					if (e.value == undefined) e.cellElement.classList.add("dx-datagrid-invalid");
				}
				if (e.column.dataField === "huAuBauBegruendung" && this.allowEditKostenvarianz()) {
					if (!this.validateGridHuAuBauBegruendung(e)) e.cellElement.classList.add("dx-datagrid-invalid");
				}
				if (e.column.dataField === "kostenermittlungsart" && this.allowEditKostenvarianz()) {
					if (e.value == undefined) e.cellElement.classList.add("dx-datagrid-invalid");
				}
				if (e.column.dataField === "veraenderungBegruendung") {
					if (!this.validateGridVeraenderung(e)) e.cellElement.classList.add("dx-datagrid-invalid");
				}
				if (e.column.dataField === "kostenvarianzBegruendung") {
					if (!this.validateGridKostenvarianzBegruendung(e)) e.cellElement.classList.add("dx-datagrid-invalid");
				}
			}

		}
	}

	onGridCalculateGroupValueKostenart(e: any) {
		if (e.kostengruppeId == 1) return "Baukosten";
		return `Baunebenkosten (${this.dataBudgetantrag()?.bnkProzent}% der Baukosten)`
	}

	onGridCalculateDisplayValueKostenart(e: any) {
		if (e.kostengruppeId == 1) return "Baukosten";
		return `Baunebenkosten (${this.dataBudgetantrag()?.bnkProzent}% der Baukosten)`
	}

	onGridCalculateGroupValueKostengruppe(e: any) {
		if (e.kostengruppeId == 2) {
			return `Baunebenkosten 1-4 (${this.dataBudgetantrag()?.bnk1bis4Prozent}% der Baunebenkosten)`
		} else if (e.kostengruppeId == 4) {
			return `Baunebenkosten 5-9 (${this.dataBudgetantrag()?.bnk5bis9Prozent}% der Baunebenkosten)`
		}
		return "Baukosten";
	}

	onGridCalculateDisplayValueKostengruppe(e: any) {
		if (e.kostengruppeId == 2) {
			return `Baunebenkosten 1-4 (${this.dataBudgetantrag()?.bnk1bis4Prozent}% der Baunebenkosten)`
		} else if (e.kostengruppeId == 4) {
			return `Baunebenkosten 5-9 (${this.dataBudgetantrag()?.bnk5bis9Prozent}% der Baunebenkosten)`
		}
		return "Baukosten";
	}

	onGridCalculateGroupValueTeilleistung(e: any) {
		if (!e.teilleistungId) return "000 - Nicht zugewiesen";
		var result = this.dataTeilleistungen()?.find((a: ITeilleistung) => a.teilleistungID === e.teilleistungId);
		return result?.anzeige;
	}

	onGridCellDisplayValueBaukosten(e: any) {
		// // [calculateDisplayValue]="onGridCellDisplayValueBaukosten"
		// if (e.kostenHerleitungId == 9999998) {
		//     return (this.dataSummaryBaukosten.baukosten * (this.dataBudgetantrag()!.bnkProzent / 100) * (this.dataBudgetantrag()!.bnk1bis4Prozent / 100)) - this.dataSummaryBNK14.baukosten;
		// }
		// if (e.kostenHerleitungId == 9999999) {
		//   return (this.dataSummaryBaukosten.baukosten * (this.dataBudgetantrag()!.bnkProzent / 100) * (this.dataBudgetantrag()!.bnk5bis9Prozent / 100)) - this.dataSummaryBNK59.baukosten;
		// }
		// return e.baukosten;
	}

	onGridCalculateCellValueBaukosten(e: any) {
		// // [calculateCellValue]="onGridCalculateCellValueBaukosten"
		// if (e.kostenHerleitungId == 9999998) {
		//   var result = (this.dataSummaryBaukosten.baukosten * (this.dataBudgetantrag()!.bnkProzent / 100) * (this.dataBudgetantrag()!.bnk1bis4Prozent / 100)) - this.dataSummaryBNK14.baukosten;
		//   console.log("Baukosten 1-4: " + result + ' Summary: ' + this.dataSummaryBNK14.baukosten);
		//   return result;
		// }
		// if (e.kostenHerleitungId == 9999999) {
		//   var result = (this.dataSummaryBaukosten.baukosten * (this.dataBudgetantrag()!.bnkProzent / 100) * (this.dataBudgetantrag()!.bnk5bis9Prozent / 100)) - this.dataSummaryBNK59.baukosten;
		//   console.log("Baukosten 5-9: " + result + ' Summary: ' + this.dataSummaryBNK59.baukosten);
		//   return result;
		// }
		// return e.baukosten;
	}

	onContextMenuPreparing(e: any) {
		if (e.target == 'headerPanel' || e.target == 'header') {

			// let menuItemToolbar = { text: this.gridShowToolbar() ? 'Werkzeugleiste ausblenden' : 'Werkzeugleiste einblenden', icon: 'search', beginGroup: 'true', onItemClick: () => { this.gridShowToolbar.set(!this.gridShowToolbar()); } };
			// let menuItemFilterRow = { text: this.gridShowFilterRow() ? 'Filterzeile ausblenden' : 'Filterzeile einblenden', icon: 'search', onItemClick: () => { this.gridShowFilterRow.set(!this.gridShowFilterRow()); } };
			// let menuItemHeaderFilter = { text: this.gridShowHeaderFilter() ? 'Spaltenfilter ausblenden' : 'Spaltenfilter einblenden', icon: 'filter', onItemClick: () => { this.gridShowHeaderFilter.set(!this.gridShowHeaderFilter()); } };

			// if (e.row?.rowType == 'header') {
			//   e.items.unshift(menuItemToolbar);
			//   e.items.unshift(menuItemFilterRow);
			//   e.items.unshift(menuItemHeaderFilter);
			//   e.items[3].beginGroup = true;
			// } else {
			//   if (e.items == undefined) e.items = [];
			//   e.items.push(menuItemHeaderFilter);
			//   e.items.push(menuItemFilterRow);
			//   e.items.push(menuItemToolbar);
			// }
		}
	}

	onGridToolbarPreparing(e: any) {
		// e.toolbarOptions.items.unshift(
		//   {
		//     name: 'customAddRowButton',
		//     location: 'after',
		//     widget: 'dxButton',
		//     options: {
		//       icon: 'add',
		//       onClick: this.onGridAddRowButtonClick.bind(this)
		//     }
		//   },
		//   {
		//     name: 'customGroupExpandButton',
		//     location: 'after',
		//     widget: 'dxButton',
		//     options: {
		//       icon: 'chevrondown',
		//       onClick: this.onGridToolbarExpandButtonClick.bind(this)
		//     }
		//   },
		//   {
		//     name: 'customGroupCollapseButton',
		//     location: 'after',
		//     widget: 'dxButton',
		//     options: {
		//       icon: 'chevronnext',
		//       onClick: this.onGridToolbarCollapseButtonClick.bind(this)
		//     }
		//   },
		// );
	}


	async onGridExporting(e: DxDataGridTypes.ExportingEvent) {
		var projektname = (this.dataBudgetantrag()?.projektName ?? 'unbekannt').replace(/[<>:"|?*\\/]/g, '');
		var filename = 'kostenherleitung ' + projektname + ' ' + new Date().toLocaleDateString() + '.xlsx';
		await this.gridService.exportDxGridToExcel(e.component, {
			worksheetName: 'Kostenherleitung ' + projektname,
			fileName: filename,
			includeHiddenColumns: true,
			includeHiddenBands: true
		});
		e.cancel = true;
	}

	onGridToolbarExpandButtonClick(e: any) {
		this.grid.instance.expandAll(2);
	}

	onGridToolbarCollapseButtonClick(e: any) {
		this.grid.instance.collapseAll(2);
	}

	// #endregion

	// #region Grid Cells

	// DevExtreme ruft Funktionen teils ohne Component-Context auf; daher nicht auf `this` verlassen.
	getFirmennameById(data: any) {
		return BudgetKostenherleitungComponent.instance.firmen()?.find(f => f.firmaID === data?.firmaId)?.firmenname ?? '';
	}

	onFirmaCustomItemCreating(e: any, cellInfo: any) {
		const text = (e.text || '').trim();
		if (!text) { e.customItem = null; return; }

		// Option A: direkt lokal hinzufügen (schnell)
		const ds = this.firmen() ?? [];
		const minId = ds.reduce((min, f) => Math.min(min, f.firmaID ?? 0), 0);
		const newItem: IFirma = { firmaID: minId - 1, firmenname: text, plangebiete: [this.plangebiet()] }; // temporäre ID
		this.firmenUnsaved.set([...this.firmenUnsaved(), newItem]);
		e.customItem = newItem;
		cellInfo.setValue(newItem.firmaID, text);
		// Zusätzlich das Textfeld "firma" (falls als eigenes DataField vorhanden) setzen:
		if (cellInfo?.row?.rowIndex != null) {
			this.grid.instance.cellValue(cellInfo.row.rowIndex, "firma", text);
		}
		this.dialogService.showMessageSheet(`Die Firma "${text}" wurde hinzugefügt und wird nach der Freigabe angelegt.`, undefined, true, "bottom", 3000);
	}

	onFirmaChanged(e: any, cellInfo: any) {
		cellInfo.setValue(e.value);
		const firma = this.firmen()?.find(f => f.firmaID === e.value);
		if (firma && cellInfo?.row?.rowIndex != null) {
			this.grid.instance.cellValue(cellInfo.row.rowIndex, "firma", firma.firmenname);
		}
	}


	setGridCellValueDefault(this: any, newData: BudgetantragKostenherleitung, value: number, currentRowData: BudgetantragKostenherleitung) {
		if (this.defaultSetCellValue) this.defaultSetCellValue(newData, value, currentRowData);
	}

	setGridCellValueKostengruppe(this: any, newData: BudgetantragKostenherleitung, value: number, currentRowData: BudgetantragKostenherleitung) {
		// it is important to set values here
		// this will trigger EditprPreparing-Event
		// but be aware - this will only work if no templates are used
		// but be aware 2 - undifined or null won't work
		// technical values will be cleared in EditorPrepared-event
		if (value !== 1) {
			newData.kostenermittlungsart = 99;
			newData.kostenvarianz = 99;
			newData.kostenvarianzBegruendung3 = '99';
			newData.huAuBauId = 99; // technical value to reset huAuBauId
			newData.huAuBauBegruendung2 = '99'; // technical value to reset huAuBauBegruendung2
		} else {
			newData.kostenermittlungsart = 98;
			newData.kostenvarianz = 98;
			newData.kostenvarianzBegruendung3 = '98';
			newData.huAuBauId = 98; // technical value to reset huAuBauId
			newData.huAuBauBegruendung2 = '98'; // technical value to reset huAuBauBegruendung2
		}

		if (this.defaultSetCellValue) this.defaultSetCellValue(newData, value, currentRowData);
	}

	onGridTextareaValueChanged(e: any, cellInfo: any, dropDownBoxComponent: any) {
		var text = e.value;
		cellInfo.setValue(text);
		dropDownBoxComponent.close();
	}

	getDataTeilleistungenFiltered(cellInfo: any) {
		if (this.isBauControlling()) {
			if (cellInfo?.row?.data?.kostengruppeId == 1) {
				return this.dataTeilleistungenBK();
			} else if (cellInfo?.row?.data?.kostengruppeId == 2) {
				return this.dataTeilleistungenBNK14();
			} else if (cellInfo?.row?.data?.kostengruppeId == 4) {
				return this.dataTeilleistungenBNK59();
			}
		}
		return this.dataTeilleistungenAll();
	}

	onGridTeilleistungSelectionChanged(e: DxDataGridTypes.SelectionChangedEvent, cellInfo: any, dropDownBoxComponent: any) {
		var selectedRowKeys = e.selectedRowKeys;
		if (selectedRowKeys.length > 0) {
			cellInfo.setValue(selectedRowKeys[0]);
			dropDownBoxComponent.close();
		}
	}

	customizeGridCellTextErmittlungsstufe(cellInfo: any) {
		return cellInfo.value + "$";
	}

	setGridCellValueKostenermittlungsart(this: any, newData: BudgetantragKostenherleitung, value: number, currentRowData: BudgetantragKostenherleitung) {
		var currentKostenermittlung: IKostenermittlungsart = this.lookup?.dataSource?.find((a: IKostenermittlungsart) => a.kostenermittlungsartID === value);
		if (currentKostenermittlung) {
			newData.kostenvarianz = currentKostenermittlung.varianz;
		}
		if (this.defaultSetCellValue) this.defaultSetCellValue(newData, value, currentRowData);
	}

	validateGridVeraenderung(e: any) {
		var minAbweichung = 0.1;
		if (e.data.baukosten && e.data.baukostenLetztgueltig) {
			if (e.data.baukosten > (e.data.baukostenLetztgueltig * (1 + minAbweichung)) || e.data.baukosten < (e.data.baukostenLetztgueltig * (1 - minAbweichung))) {
				if (e.value == null || e.value == "") {
					return false;
				}
			}
		}
		return true;
	}

	onSchlussgerechnetChanged(this: any, newData: BudgetantragKostenherleitung, value: boolean, currentRowData: BudgetantragKostenherleitung) {
		// DevExtreme may call this with a different `this` context, so use the component instance.
		if (this.defaultSetCellValue) this.defaultSetCellValue(newData, value, currentRowData);
		if (value === true)
			BudgetKostenherleitungComponent.instance?.dialogService.showMessageSheet("Wenn Sie die Teilleistung auf schlussgerechnet setzen, wird das Budget auf den aktuellen Abrechnungsstand und die Kostenvarianz auf 0 gesetzt!", undefined, undefined, undefined, 5000);

	}

	validateGridHuAuBau(e: any) {
		if (e.data.kostengruppeId && e.data.kostengruppeId !== 1) {
			// Für Baunebenkosten keine Pflichtfeld
			return true;
		}

		if (e.value === undefined || e.value === null || e.value === 98 || e.value === 99) {
			return false;
		}

		return true;
	}

	validateGridHuAuBauBegruendung(e: any) {
		// validation needed in RowEdit
		if (e.data.kostengruppeId && e.data.kostengruppeId !== 1) {
			// Für Baunebenkosten keine Pflichtfeld
			return true;
		}

		if (e.data.huAuBauId == 0) {
			if (e.value == null || e.value == "") {
				return false;
			}
		}
		return true;
	}

	validateGridHuAuBauBegruendung2(e: any) {
		// validation only needed in EditDialog
		// technical values to trigger EditorPrepared-event
		// no validation required
		if (e.data.huAuBauId == 98 || e.data.huAuBauId == 99) return true;

		if ((e.data.kostengruppeId === undefined || e.data.kostengruppeId === 1) && e.data.huAuBauId == 0) {
			if (e.value == null || e.value == "" || e.value == 98 || e.value == 99) {
				return false;
			}
		}
		return true;
	}

	validateGridKostenermittlungsart(e: any) {
		if (e.data.kostengruppeId && e.data.kostengruppeId !== 1) {
			// Für Baunebenkosten keine Pflichtfeld
			return true;
		}

		if (e.value == null || e.value == "" || e.value === 98 || e.value === 99) {
			return false;
		}

		return true;
	}

	validateGridKostenvarianzBegruendung(e: any) {
		if (e.data.kostengruppeId && e.data.kostengruppeId !== 1) {
			// Für Baunebenkosten keine Pflichtfeld
			return true;
		}

		if ((e.data.kostenermittlungsart == 1 && e.data.kostenvarianz != 0.2) ||
			(e.data.kostenermittlungsart == 2 && e.data.kostenvarianz != 0.15) ||
			(e.data.kostenermittlungsart == 3 && e.data.kostenvarianz != 0.1) ||
			(e.data.kostenermittlungsart == 5 && e.data.kostenvarianz != 0.05) ||
			(e.data.kostenermittlungsart == 4 && e.data.kostenvarianz != 0.0)) {
			if (e.value == null || e.value == "") {
				return false;
			}
		}
		return true;
	}

	validateGridKostenvarianzBegruendung3(e: any) {
		// validation only needed in EditDialog
		// technical values to trigger EditorPrepared-event
		// no validation required
		if (e.data.kostenermittlungsart == 98 || e.data.kostenermittlungsart == 99) return true;

		if ((e.data.kostengruppeId === undefined || e.data.kostengruppeId === 1) &&
			((e.data.kostenermittlungsart == 1 && e.data.kostenvarianz != 0.2) ||
				(e.data.kostenermittlungsart == 2 && e.data.kostenvarianz != 0.15) ||
				(e.data.kostenermittlungsart == 3 && e.data.kostenvarianz != 0.1) ||
				(e.data.kostenermittlungsart == 5 && e.data.kostenvarianz != 0.05) ||
				(e.data.kostenermittlungsart == 4 && e.data.kostenvarianz != 0.0))) {
			if (e.value == null || e.value == "" || e.value == 98 || e.value == 99) {
				return false;
			}
		}
		return true;
	}


	validateGridPDFKalkulation(e: any) {
		if (e.data.kostenermittlungsart == 3 && e.data.dateipfadPDFKalkulation == null)
			return false;
		else
			return true;
	}

	validateGridVertragsgegenstand(e: any) {
		var existingAuftrag = (e.data && e.data.auftrag != undefined);
		if ((!existingAuftrag)) {
			if (e.value == null || e.value == "") {
				return false;
			}
		}
		return true;
	}

	validateGridBerechnungsgrundlage(e: any) {
		if ((e.data.basiskosten && e.data.menge)) {
			if (e.value == null || e.value == "") {
				return false;
			}
		}
		return true;
	}

	// #endregion

	// #region GridSummaries

	isTeileistungSonstiges(teilleistungId: number): boolean {
		// unclear specification, further agreements with the customer to be expected - commented out until further notice
		//return false;
		return (teilleistungId == 385 || teilleistungId == 347);
	}

	onGridCalculateCustomSummary(options: any) {
		// wichtig hierbei ist die Namenskonvention der Summaries: name = columnname
		if (options.name === "kostenvarianz")
			this.calculateSummary(options, "basiskostenBudget", options.groupIndex != undefined ? 1 : 0);
		else
			this.calculateSummary(options, "baukosten");
	}

	calculateSummary(options: any, sumName: string, kostengruppeId: number = 0) {
		// wichtig hierbei ist die Namenskonvention der Summaries: name = columnname
		switch (options.summaryProcess) {
			case "start": options.totalValue = 0;
				break;
			case "calculate":
				options.totalValue += (options.value[options.name] ?? 0) * (options.value?.[sumName] ?? 0);
				break;
			case "finalize":
				const totalBudget = this.dataKostenherleitungen()?.reduce((sum, item) => {
					if (item.kostenHerleitungId !== 9999998 && item.kostenHerleitungId !== 9999999) {
						if (kostengruppeId === 0 || item.kostengruppeId === kostengruppeId)
							return sum + ((item as any)[sumName] ?? 0);
					}
					return sum;
				}, 0) ?? 0;
				options.totalValue = totalBudget > 0 ? options.totalValue / totalBudget : 0;
				break;
		}
	}


	// #endregion

	// #region Grid FileUpload


	onFileUploadCloseButtonClick() {
		this.dropDownBoxFileUpload.instance.close();
	}

	onFileUploadValueChanged(e: ValueChangedEvent, cellInfo: any): void {
		const reader: FileReader = new FileReader();
		reader.onload = (args) => {
			if (typeof args.target?.result === 'string') {
				var resultBase64 = args.target.result as string;
				var resultFile = this.convertBase64ToFile(resultBase64, e.value![0].name);
				this.dataFileKalkulation.set(resultFile);
				this.gridIsKalkulationModified.set(true);
			}
		};
		// set filename to datafield
		cellInfo.setValue(e.value![0].name);
		// convert to base64 string
		reader.readAsDataURL(e.value![0]);
	}

	onFileUploadShowButtonClick(cellInfo: any): void {
		if (this.dataFileKalkulation().size != 0) {
			window.open(this.dataFileURLKalkulation(), '_blank');
		}
	}

	onFileShowButtonClick(e: any): void {
		if (e.data.dateipfadPDFKalkulation && e.data.kostenHerleitungId) {
			// load file 
			this.dataService.readBudgetantragKostenherleitungKalkulation(this.appStateService.budgetantragId(), e.data.kostenHerleitungId!).subscribe({
				next: (data: any) => {
					var dataFile = signal<File>(new File([], ''));
					dataFile.set(data);
					if (dataFile().size != 0) {
						window.open(URL.createObjectURL(dataFile()!), '_blank');
					}
				}
			});
		}
	}

	onFileUploadDeleteButtonClick(cellInfo: any): void {
		if (this.dataFileKalkulation().size != 0) {
			URL.revokeObjectURL(this.dataFileURLKalkulation()!);
		}
		cellInfo.setValue(null);
		this.fileUploader.instance.option("value", []);
		this.dataFileKalkulation.set(new File([], ''));
	}

	private convertBase64ToBlob(base64Image: string) {
		// Split into two parts
		const parts = base64Image.split(';base64,');
		// Hold the content type
		const imageType = parts[0].split(':')[1];
		// Decode Base64 string
		const decodedData = window.atob(parts[1]);
		// Create UNIT8ARRAY of size same as row data length
		const uInt8Array = new Uint8Array(decodedData.length);
		// Insert all character code into uInt8Array
		for (let i = 0; i < decodedData.length; ++i) {
			uInt8Array[i] = decodedData.charCodeAt(i);
		}
		// Return BLOB image after conversion
		return new Blob([uInt8Array], { type: imageType });
	}

	private convertBase64ToFile(base64Image: string, fileName: string) {
		// Split into two parts
		const parts = base64Image.split(';base64,');
		// Hold the content type
		const imageType = parts[0].split(':')[1];
		// Decode Base64 string
		const decodedData = window.atob(parts[1]);
		// Create UNIT8ARRAY of size same as row data length
		const uInt8Array = new Uint8Array(decodedData.length);
		// Insert all character code into uInt8Array
		for (let i = 0; i < decodedData.length; ++i) {
			uInt8Array[i] = decodedData.charCodeAt(i);
		}
		// Return BLOB image after conversion
		var blob = new Blob([uInt8Array], { type: imageType });

		return new File([blob], fileName, { type: imageType });
	}

	// #endregion
}
